export default __webpack_public_path__ + "static/home-custom-plugins-496af54619eecec5c9a9df9177f6dfd6.png";